module.exports = __webpack_public_path__ + "img/logo.b712c0e1.png";